import { Stack, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { routerPaths } from "../../constants/Paths";
import TicketDetailsBoardComponent from "../../components/panel/ticket-detail-board/TicketDetailsBoard";
import { useState } from "react";
import { TicketNoteCreateRequest } from "../../services/Endpoints/tickets/TicketNoteCreateEndpoint";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import errorResolver from "../../utils/error-resolver";
import { useNotificationContext } from "../../context/notificationContext";
import { LoadingButton } from "@mui/lab";
import { IUserLink } from "../../components/panel/common/UserLink";
import UserOverviewCard from "../../components/panel/common/UserOverviewCard";
import { useCanAccess } from "../../hooks/canAccess";
import { AccessEnums } from "../../constants/accessEnum";

export default function TicketDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();
  const [creator, setCreator] = useState<IUserLink["user"] | undefined>(
    undefined
  );

  const [waiting, setWaiting] = useState(false);
  const [status, setStatus] = useState("");
  const { can } = useCanAccess();
  const closeTicket = async () => {
    setWaiting(true);
    try {
      const ticketNoteCreateEndpoint = new TicketNoteCreateRequest(
        protectedInstance
      );

      await ticketNoteCreateEndpoint.close({ ticketNumber: id! });
      setWaiting(false);
      navigate("/" + routerPaths.SUPPORT);
    } catch (error: any) {
      errorResolver({ error, setNotification });

      setWaiting(false);
    }
  };
  const inProcessTicket = async () => {
    setWaiting(true);
    try {
      const ticketNoteCreateEndpoint = new TicketNoteCreateRequest(
        protectedInstance
      );

      await ticketNoteCreateEndpoint.inProcess({ ticketNumber: id! });
      setWaiting(false);
    } catch (error: any) {
      errorResolver({ error, setNotification });

      setWaiting(false);
    }
  };

  return (
    <Fragment>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        {creator && <UserOverviewCard user={creator} />}
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={({ palette }) => palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                جزئیات تیکت
              </Typography>
              <Typography
                variant="footerDemiBold"
                color={({ palette }) => palette.complement[300]}
                sx={{
                  mb: "20px",
                }}
              >
                تیکت ها / جزئیات تیکت
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            >
              <LoadingButton
                loading={waiting}
                disabled={
                  status == "in_progress" ||
                  !can(AccessEnums.AdminTicketsSendToInProgress)
                }
                onClick={() => inProcessTicket()}
                variant="activeOutlined"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                }}
              >
                ارسال به در حال بررسی
              </LoadingButton>
              <LoadingButton
                loading={waiting}
                disabled={
                  status == "closed" || !can(AccessEnums.AdminTicketsClose)
                }
                onClick={() => closeTicket()}
                variant="contained"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                }}
              >
                بستن تیکت
              </LoadingButton>
            </Stack>
          </Stack>
        </Stack>
        <TicketDetailsBoardComponent
          ticketNumber={id!}
          setCreator={setCreator}
          setStatus={setStatus}
        />
      </Stack>
    </Fragment>
  );
}
